import { Component, Input } from "@angular/core";
import { EInvoiceReceivedGridItem, PurchaseGridItem } from "@skylab-angular-shared/business";
import { TooltipDirective, IconComponent } from "@skylab-angular-shared/ui";
import { PaymentStatus } from "@skylab-shared/dataModel";
import { CommonColors } from "@inscomponents/core";
import { IconName } from "@skylab-assets/icons";
import { isEInvoicesGridItem } from "../../dialogs/purchase-service-payment/purchase-service-payment-dialog.component";
import { PurchaseServicePaymentDataProvider } from "./purchase-service-payment-data-provider.service";

type Entity = PurchaseGridItem | EInvoiceReceivedGridItem;

@Component({
    selector: 'skl-purchase-service-payment-status-cell',
    template: `
		<skl-icon
			class="text--clickable"
			(click)="openDialog()"
			[tooltip]="tooltip"
			[color]="iconColor"
			[name]="iconName"
			size="16px">
		</skl-icon>
    `,
    styles: [`
        :host {
            display: flex;
            justify-content: center;
        }
    `],
    imports: [TooltipDirective, IconComponent]
})
export class PurchaseServicePaymentStatusCellComponent {
    @Input() public entity!: Entity;

    public constructor(
        private readonly paymentDataProvider: PurchaseServicePaymentDataProvider
    ) { }

    public openDialog(): void {
        if (isEInvoicesGridItem(this.entity) && !this.entity.documentNumber) {
            return;
        }

        this.paymentDataProvider.openPaymentDialog(this.entity);
    }

    public get iconName(): IconName | undefined {
        if (isEInvoicesGridItem(this.entity) && !this.entity.documentNumber) {
            return 'circle-empty';
        }

        const status = this.paymentDataProvider.getPaymentStatus(this.entity);
        if (!status) return undefined;

        switch (status) {
            case PaymentStatus.Paid:
            case PaymentStatus.Unpaid:
                return 'paid';
            case PaymentStatus.Overdue:
                return 'payment-expired';
        }
    }

    public get iconColor(): CommonColors | undefined{
        if (isEInvoicesGridItem(this.entity) && !this.entity.documentNumber) {
            return 'secondary';
        }

        const status = this.paymentDataProvider.getPaymentStatus(this.entity);
        if (!status) return undefined;

        switch (status) {
            case PaymentStatus.Paid:
                return 'success';
            case PaymentStatus.Unpaid:
            case PaymentStatus.Overdue:
                return 'error';
        }
    }

    public get tooltip(): string {
        return this.paymentDataProvider.getPaymentStatusText(this.entity);
    }
}
